import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { ReadPayrollType, CreatePayrollType } from "@/types/payrollType";

export const usePayrollTypesDictionary = () => {
  const config = getDictionaryConfig<ReadPayrollType, CreatePayrollType>(
    Module.PayrollTypes,
  );
  return config;
};
